<template>
    <div>
        <b-input-group size="sm" prepend="Plan de charge type">
            <b-form-select
                v-model="form.charge_template_id"
                size="sm"
                :options="chargeTemplates"
                @change="handleNewChargeTemplate"
            >
                <template #first>
                    <b-form-select-option :value="null">
                        Aucun (saisie manuelle)
                    </b-form-select-option>
                </template>
            </b-form-select>
        </b-input-group>
        <b-modal
            ref="apply-template-modal"
            hide-footer
            title="Application du plan de charge type"
        >
            <div v-if="form.charge_template_id === null">
                <p>Etes-vous sûr de désactiver le plan de charge type ?</p>
                <b-button variant="success" @click="resetChargeTemplate">
                    Valider
                </b-button>
                <b-button variant="secondary" @click="hideModal">
                    Annuler
                </b-button>
            </div>
            <div v-else>
                <p>
                    A partir de quand souhaitez-vous appliquer les valeurs de ce
                    plan de charge sur les échéances ?
                </p>
                <b-input-group class="mb-3">
                    <b-form-input
                        id="current-date"
                        v-model="formatted_current_date"
                        type="text"
                        autocomplete="off"
                        disabled
                        class="bg-white"
                    />
                    <b-input-group-append>
                        <b-form-datepicker
                            v-model="form.from_date"
                            button-only
                            right
                            size="sm"
                            label-no-date-selected="A partir du..."
                            label-prev-year="Année précédente"
                            label-next-year="Année prochaine"
                            label-prev-month="Mois précédent"
                            label-next-month="Mois prochain"
                            label-current-month="Mois actuel"
                            label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                            start-weekday="1"
                            aria-controls="current-date"
                            locale="fr"
                            @context="formatCurrentDate"
                        >
                        </b-form-datepicker>
                    </b-input-group-append>
                </b-input-group>
                <b-button
                    variant="success"
                    :disabled="form.from_date === null"
                    @click="applyChargeTemplate"
                >
                    Enregistrer
                </b-button>
                <b-button variant="secondary" @click="hideModal">
                    Annuler
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ToastHandler from '../../../invoicing/mixins/ToastHandler.vue'

export default {
    name: 'ChargeTemplateHandler',

    mixins: [ToastHandler],

    props: {
        chargeTemplateId: {
            required: false,
            type: Number,
            default: null
        },
        clientId: {
            required: true,
            type: Number,
        },
    },

    data() {
        return {
            chargeTemplates: [],
            form: {
                charge_template_id: null,
                from_date: null,
            },
            formatted_current_date: '',
        }
    },

    async created() {
        await this.getChargeTemplates()
        this.form.charge_template_id = this.chargeTemplateId
        this.form.from_date = new Date()
    },

    methods: {
        async getChargeTemplates() {
            try {
                const response = await this.$axios.get(`/chargeTemplates`)
                this.chargeTemplates = response.data.data
            } catch (error) {
                //
            }
        },

        handleNewChargeTemplate() {
            this.$refs['apply-template-modal'].show()
        },

        async applyChargeTemplate() {
            this.showRecordingToast()
            try {
                const response = await this.$axios.post(
                    `clients/${this.clientId}/chargeTemplates/${this.form.charge_template_id}/apply`,
                    this.form
                )
                this.handleRecordingResponse(response.data.meta)
                this.hideModal()
                this.$emit('template-is-updated')
            } catch (error) {
                //
            }
        },

        async resetChargeTemplate() {
            this.showRecordingToast()
            try {
                const response = await this.$axios.post(
                    `clients/${this.clientId}/chargeTemplates/reset`,
                    this.form
                )
                this.handleRecordingResponse(response.data.meta)
                this.hideModal()
            } catch (error) {
                //
            }
        },

        hideModal() {
            this.$refs['apply-template-modal'].hide()
        },

        formatCurrentDate(ctx) {
            this.formatted_current_date = ctx.selectedFormatted
        },
    },
}
</script>

<style scoped></style>
